import {ChangeDetectionStrategy, Component, OnDestroy} from '@angular/core';
import {ICellRendererAngularComp} from 'ag-grid-angular';
import {ICellRendererParams} from 'ag-grid-community';
import {GridUtils} from '../../../../shared-utilities/utils-old/grid-utils-old/grid-utils';
import {Store} from '@ngrx/store';
import {Observable, Subject} from 'rxjs';
import {setEditedItem} from '../../../../features/stock-manager/store/stock-manager.actions';
import {selectCurrentNavigationPage} from '../../../../features/user-access/user-stores-store/user-store.selectors';
import {take} from 'rxjs/operators';
import {NGPReport} from '../../../../shared-utilities/models-old/ngp-reports/ngp-report';

@Component({
    selector: 'app-cell-renderer-text',
    templateUrl: './cell-renderer-text.component.html',
    styleUrls: ['./cell-renderer-text.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CellRendererTextComponent implements ICellRendererAngularComp, OnDestroy {

  value: string;
  params: ICellRendererParams;
  width: string;
  type: string;
  currentPage$: Observable<string>;
  currentPage: string;

  private destroy$ = new Subject<boolean>();

  constructor(
    private readonly store: Store,
  ) {
  }

  agInit(params: ICellRendererParams): void {
    this.currentPage$ = this.store.select(selectCurrentNavigationPage);
    this.currentPage$.pipe(take(1)).subscribe((page: string) => {
      this.currentPage = page;
    });
    this.value = params.value;
    this.params = params;

  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }


  refresh(params: ICellRendererParams): boolean {
    return false;
  }

  areArraysEqual(): boolean {
    if (Array.isArray(this.value)) {
      const pos = this.params.column.getColDef().field;
      const arraysAreEqual = (arr1: string[], arr2: string[]): boolean => {
        if (!arr1 || !arr2) {
          return false;
        }
        if (arr1.length !== arr2.length) {
          return false;
        }
        return arr1.every((value, index) => {
          return value === arr2[index];
        });
      };
      if (typeof this.params.data[pos] === 'string') {
        this.params.data[pos] = this.params.data[pos].split(',');
      }
      return !arraysAreEqual(this.params?.data?.[pos]?.filter((item: string) => item !== "") as string[], this.params?.data?.originalValue?.[pos]?.value as string[]);

    } else {
      return true;
    }

  }

  onUndoChangesClick(): void {
    this.params = {...this.params};
    this.params.data = structuredClone(this.params.data);
    this.value = this.params.data.originalValue[this.params.colDef.field].value;
    this.params.data[this.params.colDef.field] = this.value;
    if (this.currentPage === 'ngp-report') {
      void GridUtils.removeIsEditingFlagFromNgpItem(this.params.data as NGPReport, this.params.colDef.field, this.store);
    } else {
      this.store.dispatch(setEditedItem({stockItem: this.params.data}));
    }
    GridUtils.updateIsEditedAndForceRefresh(this.params);
  }
}
